import React from "react";
import { Switch, BrowserRouter, Redirect } from "react-router-dom";
import Route from "./Route";
import { Dashboard, Software, Firmware, Locks, Peripherals, Versions, Product, FeatureBugs, NotFound } from './../pages/index';

export default function Routes() {

  return (
    <BrowserRouter>
      <Switch>

        <Route path="/firmware/:locks_or_peripherals/:url/:name/:version" component={props => <FeatureBugs {...props} />} />
        <Route path="/firmware/:locks_or_peripherals/:url" component={Product} />
        <Route path="/firmware/locks" component={Locks} />
        <Route path="/firmware/peripherals" component={Peripherals} />
        <Route path="/firmware" component={Firmware}  />
        <Route path="/software/:url/:name/:version" component={FeatureBugs}  />
        {/* <Route path="/software/:url/:name/:version" component={FeatureBugs}  /> */}
        <Route path="/software/:url" component={props => <Versions {...props}/>} />
        <Route path="/software" component={Software} />
        <Route path="/404" component={NotFound} isPrivate="false" />
        <Route path="/" component={Dashboard} />
        <Redirect to="/404" component={NotFound} isPrivate="false" />
        {/* redirect user to SignIn page if route does not exist and user is not authenticated */}
        {/* <Route component={SignIn} /> */}
        <Route path="*" component={NotFound} isPrivate="false" />
        
        
      </Switch>
    </BrowserRouter>
    
  );
}
